import { FC } from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { MenuItem, Grid, Box, TextField, InputAdornment } from '@mui/material';
import { Close, Search } from '@mui/icons-material';
import { FiltersButtons, FiltersLayout, SMBSelect } from '../../../components';

interface INeighborhoodFilters {
  isLoading: boolean;
  applyFilters: (clearFilters?: boolean) => void;
  searchValue: string;
  setSearch: (val: string) => void;
  setSearchedValue: (val: string) => void;
  setPage: (val: number) => void;
  handleSearch: (clearSearch?: boolean) => void;
  setHasAppliedFilters: (val: boolean) => void;
  hasAppliedFilters?: boolean;
  neighborhoodNames: { name: string }[];
  setSelectedName: (val: string) => void;
  selectedName: string;
}

export const NeighborhoodFilters: FC<INeighborhoodFilters> = ({
  hasAppliedFilters,
  setHasAppliedFilters,
  isLoading,
  applyFilters,
  searchValue,
  setSearch,
  setSearchedValue,
  neighborhoodNames,
  selectedName,
  setSelectedName
}) => {
  const classes = useStyles();

  return (
    <FiltersLayout>
      <Grid item xs={12} sm={6} md={3}>
        <Box display="flex">
          <TextField
            size="small"
            fullWidth
            variant="outlined"
            placeholder="Search..."
            name="search"
            value={searchValue}
            disabled={isLoading}
            InputProps={{
              startAdornment: (
                <InputAdornment
                  position="start"
                  className={classes.searchIcon}
                  onClick={() => {
                    if (searchValue.length > 0) {
                      setHasAppliedFilters(true);
                      setSearchedValue(searchValue);
                    }
                  }}
                >
                  <Search />
                </InputAdornment>
              ),
              endAdornment: searchValue ? (
                <InputAdornment
                  position="end"
                  className={classes.searchIcon}
                  onClick={() => {
                    setHasAppliedFilters(false);
                    setSearch('');
                    setSearchedValue('');
                  }}
                >
                  <Close />
                </InputAdornment>
              ) : null
            }}
            onKeyDown={e => {
              if (e.key === 'Enter' && searchValue.length > 0) {
                setHasAppliedFilters(true);
                setSearchedValue(searchValue);
              }
            }}
            onChange={e => {
              setSearch(e.target.value);
            }}
          />
        </Box>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <SMBSelect
          disabled={isLoading}
          name="role"
          label="Name"
          variant="outlined"
          handleClear={() => setSelectedName('')}
          id="role"
          value={selectedName}
          onChange={({ target: { value } }) => setSelectedName(value)}
        >
          {neighborhoodNames &&
            neighborhoodNames.map((n, index) => {
              return (
                <MenuItem key={`${index}`} value={n.name}>
                  {n.name}
                </MenuItem>
              );
            })}
        </SMBSelect>
      </Grid>
      <Grid item xs={12} md={4}>
        <FiltersButtons
          hasAppliedFilters={hasAppliedFilters}
          isDisabled={isLoading}
          handleApplyFilters={() => {
            setSearchedValue(searchValue);
            setHasAppliedFilters(true);
            applyFilters();
          }}
          handleResetFilters={() => {
            setHasAppliedFilters(false);
            setSearch('');
            setSearchedValue('');
            setSelectedName('');
            applyFilters(true);
          }}
        />
      </Grid>
    </FiltersLayout>
  );
};

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  searchIcon: {
    cursor: 'pointer',
    color: theme.palette.grey[500]
  }
}));
